
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"127","height":"127","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M118.476 66.818a11.857 11.857 0 00-1.458-16.695L66.728 7.935a11.827 11.827 0 00-16.705 1.447L7.798 59.664a11.82 11.82 0 001.457 16.682l50.29 42.192a11.865 11.865 0 0016.716-1.461l42.215-50.259zm-84.892-1.002l26.97-32.113 32.13 26.952-26.97 32.114-32.13-26.953z","fill":"#9C227D"}})])
          )
        }
      }
    